const en_solutions = require('./en_solutions')
const en_products = require('./en_products')
module.exports = {
  companyName: '全线通',
  header: {
    home: 'Home',
    news: 'News',
    coreTechnology: 'Core Technologies',
    product: 'News',
    solution: 'Solutions',
    partner: '合作伙伴',
    aboutUs: 'About Us',
    contactUs: 'Contact Us',
    joinUs: 'Join Us',
    productMenu: {
      robot: 'Smart Robots',
      chip: 'Smart Modules',
      terminal: 'Smart Terminals',
      car: 'AI Patrol Car'
    },
    solutionMenu: {
      airport: 'Air Transport',
      education: 'Coordinated Transport',
      port: 'Sea Transport',
      traffic: 'Rail Transport'
    }
  },
  common: {
    learnMore: 'Learn More',
    viewVideo: 'Play Video'
  },
  // 首页
  home: {
    banner: {
      banner1Info: 'Take the Silk Road and Create a Better Tomorrow ',
    },

    product: 'Company Products',
    logistics: 'LTMS',
    logisticsProject0: 'End-to-end integrated logistics',
    logisticsDetail0: 'Indulge in the mountains and rivers, wantonly in the five mountains of Kyushu',
    logisticsProject1: 'International multimodal transport',
    logisticsDetail1: 'Including international railway transport, sea-rail combined transport, steam-rail combined transport, air transport, etc.',
    logisticsProject2: 'International container train',
    logisticsDetail2: 'In response to the great initiative of the "Belt and Road Initiative" and provide the operation of the outbound section of the China-Europe freight train',
    logisticsProject3: 'Engineering project logistics',
    logisticsDetail3: 'For large, heavy equipment, machinery, precision instruments and other special goods',
    logisticsProject4: 'International road transport ',
    logisticsDetail4: 'The business involves the transportation of petroleum engineering, chemical engineering, water conservancy and hydropower projects, electric power engineering, large machinery, etc. in Central Asia and West Asia',
    logisticsProject5: 'Cross-border e-commerce logistics',
    logisticsDetail5: 'Help cross-border e-commerce companies enhance market competitiveness',
    logisticsProject6: 'International air transport ',
    logisticsDetail6: 'Whole machine charter, semi-charter, personalized customization',
    logisticsProject7: 'International sea transportation',
    logisticsDetail7: 'Mainly engaged in seaborne container cargo, seaborne import services, seaborne bulk cargo transportation, seaborne export and LCL cargo such as China-Hong Kong barges',

    warehouse: 'WMS',
    warehouseProject0: 'Warehousing + Distribution + System',
    warehouseDetail0: 'Sea memory confidant, the end of the world is like a neighbor',
    warehouseProject1: 'Domestic bonded warehousing',
    warehouseDetail1: 'With its own modern warehousing and logistics center, with rich warehousing management experience and advanced facilities and equipment, international standardized operations, mature solutions and professional logistics management team, to provide customers with satisfactory warehousing and logistics services',
    warehouseProject2: 'Overseas warehouse service',
    warehouseDetail2: 'In overseas cities such as Hamburg, Warsaw, Moscow, Tashkent, and Almaty, overseas warehouses have been established, warehouse management and distribution centers have been set up, and warehouse management services have been continuously optimized and upgraded',
    warehouseProject3: 'Cross-border e-commerce warehousing',
    warehouseDetail3: 'Provide cross-border e-commerce sellers with comprehensive, high-quality, time-stable, and cost-effective cross-border logistics and warehousing services, help cross-border e-commerce sellers optimize supply chains, reduce logistics costs, avoid out-of-stock risks, worry-free replenishment, and products big sale',
    warehouseProject4: 'Customized Shipping Service',
    warehouseDetail4: 'Provide warehousing management for cross-border e-commerce customers, the first journey of order out and storage, customs clearance and the last mile service of the last journey, door-to-door delivery for customers, and full logistics tracking information',

    container: 'CMS',
    containerProject0: 'Box Carrier',
    containerDetail0: 'Be tolerant to diversity, tolerance is a virtue',
    containerProject1: 'Yard and Maintenance Services',
    containerDetail1: 'Provide one-stop container leasing and yard services for inland countries',
    containerProject2: 'Container Leasing',
    containerDetail2: 'Advanced information system provides high-quality and efficient services',
    containerProject3: 'Second-hand container sale',
    containerDetail3: 'Have an experienced professional container service team',
    containerProject4: 'Container agency operation',
    containerDetail4: 'Has a number of professionals and IT management technical backbones engaged in the Belt and Road container management business',

    supplyChain: 'SCMS',
    supplyChainProject0: 'Container agency operation',
    supplyChainDetail0: 'In the midst of strategizing, the decisive victory is thousands of miles away',
    supplyChainProject1: 'Import and export declaration',
    supplyChainDetail1: 'The company has obtained the first-class freight forwarding enterprise qualification issued by the Ministry of Commerce of the People\'s Republic of China, and has industry qualifications such as "International Shipping Agency", "NVOCC" and professional (container) road transportation license issued by the Ministry of Communications.',
    supplyChainProject2: 'Overseas sales agent',
    supplyChainDetail2: 'It is a member of Continental Bridge (the world\'s largest cross-border transportation service platform for international railway logistics industry) and a member of China International Freight Association (CIFA).',
    supplyChainProject3: 'Domestic and foreign purchasing agents',
    supplyChainDetail3: 'The company has set up multiple branches at home and abroad, which can better purchase a variety of excellent "Made in China" products for overseas customers',
    supplyChainProject4: 'Supply chain finance',
    supplyChainDetail4: 'Provide logistics, fund settlement, information processing and other services to help customers achieve overseas distribution and delivery, reduce channel inventory, control transaction risks, speed up payment collection turnover rate, and enhance customer competitiveness',

    describe: 'Guangdong Quanxiantong International Supply Chain Co., Ltd. is located in Shenzhen, the South Gate and Special Economic Zone of China. We take the China-Europe train as our core business, covering the China-Europe, China-Russia, Central Asia railway container freight, domestic trade rail transport, sea-rail intermodal transport and other fields.',

    // 智能机器人
    robot: 'Smart Robots',
    title1: 'Interact in a Smart Way \nImagine with No Limits',
    tip1: 'AI Robots : Apply in various scenarios to meet diverse needs from the clients',

    guiding: 'Smart Direction Robot',
    tip2: 'Face recognition and free selection of visit spots',

    educationRobot: 'Smart Education Robot',
    tip3: 'Provide intelligent education demonstration, track, check attendance, and audio control, etc.',

    security: 'Smart Security Robot',
    tip4: 'Intelligent patrolling with self-planning route and video analysis based off Local Intelligence technology',

    delivery: 'Smart Delivery Robot',
    tip5: 'Intelligent delivery with automatic biometrics identification',

    home: 'Smart Home Robot',
    tip6: 'Intelligent assistant for home and office',
    // 智能终端
    terminal: 'Smart Terminals',
    title2: 'Intelligent Terminals for \nConvenient Life',
    tip7: 'Multiple intelligent terminal devices to meet different needs in your work and life',

    eye: 'Smart Cat Eye',
    tip8: 'Provide a clear vision of your door front via intelligent intrusion alert, remote doorbells, and behavioral analysis of strangers',

    access: 'Smart Access Control',
    tip9: 'Offer services such as rapid face recognition authentication and smart attendance check',

    ADAS: 'Advanced Driver Assistance System (ADAS)',
    tip10: 'Make your trip safer with in-vehicle AI modules, smart sensors and AI algorithms',

    access2: 'Smart Temperature Detection System',
    tip22: 'Feature real-time body temperature detection, face recognition and identification check',
    // 智能模组
    chip: 'Smart Modules',
    title3: 'Smart Modules \nEnable Power with No Limits',
    tip11: 'Enable More Power with AI Technology',
    neuromorphic: 'Core Board of Intelligent Terminal',
    tip12: 'Capable of high–performance and independent development of an extensive range of embedded AI products',
    module: '“Learning-on-chip” Smart Module',
    tip13: 'Design in high-efficiency structure and combine with  both “Local Intelligence” and online learning technologies',
    //智能巡检车
    vehicle: 'AI Patrol Car',
    title4: 'Intelligent Patrol and \nInspection with Safety \nand Efficiency',
    tip14: 'AI Patrol Car : Intelligent patrol and inspection to secure safety in an efficient way',
    trolley: 'AI Patrol Car',
    tip15: 'Available in basic and advanced versions for different needs',
    // 核心技术
    coreTechnology: 'Business Scope',
    message1: 'China-Europe and Central Asia international intermodal transport products: provide international multimodal transport logistics services for companies from all over the country to Guangzhou, Zhengzhou, Xi\'an, Chengdu, Chongqing and other places, and to countries in Europe (Mara, Lodz, Tilburg, Duisburg, Hamburg, Budapest and other cities) and Central Asia (Almaty, Tashkent and other cities) by rail trains;\n' +
      '\n' +
      'Sino-Russian international intermodal transport products: provide international multimodal transport logistics services for companies from the China to Shenzhen, Guangzhou, Zhengzhou, Xi\'an, Chengdu, Chongqing and other places, and transport them to Russia (the whole territory) by railway trains;',
    localIntelligent: 'Local Intelligence',
    face: 'Face Analysis',
    action: 'Behavior Analysis',
    defect: 'Defect Analysis',
    target: 'Target Analysis',
    hxVideo: 'Video Analysis',
    hxData: 'Data Analysis',

    solution: 'Solutions',
    airport: 'Air Transport',
    apron: 'Air Transport',
    park: 'Smart \nPublic Park',
    message2: 'Smart Public Park / Smart Building / Smart\nOffice / Smart Community',
    education: 'Coordinated\nTransport',
    message3: 'Coordinated Transport',
    medical: '智慧医疗',
    message4: '智慧医院 / AI辅诊',
    detection: 'Smart Detection',
    message5: 'High-precision Industrial Vision Measurement /\nStrip Steel Defect Detection',
    port: 'Sea Transport',
    message6: 'Sea Transport',
    traffic: 'Rail Transport',
    message11: 'Railway Transport',
    moreSolution: 'More solutions',

    partner: 'Partner',
    // 集团网络
    network: 'Corporate Network',
    message7: 'Mind PointEye is currently operating in Yantai, Yangzhou and Singapore, and is also in the process of setting up the branch offices in Beijing, Shanghai, Shenzhen, Chongqing, and Nanjing, building up the connections across the world.',
    yantai: 'Yantai',
    message8: {
      message80: 'Corporate Headquarter',
      message81: 'Building No.16, WISE VALLEY, 2 Lanhai Road, Yantai Hi-tech Zone, Yantai City, Shandong Province, China',
    },
    yangzhou: 'Yangzhou',
    message9: {
      message90: 'Branch Office',
      message91: '505-1 Changjiang West Road, Jiangdu, Yangzhou City, Jiangsu Province, China',
    },
    singapore: 'Singapore',
    singaporetips: 'Vision Exchange, 2 Venture Drive, #08-25, Singapore',
    message10: 'Branch Office',
    beijing: 'Beijing',
    shanghai: 'Shanghai',
    shenzhen: 'Shenzhen',
    chongqing: 'Chongqing',
    nanjing: 'Nanjing',
    none: 'Coming Soon…',

    mainLine: 'Main line',
    chinaRailwayExpress: 'China Railway Express',
    chinaRailwayExpress1: 'China, Belarus and Ukraine',
    chinaRailwayExpress2: 'Russia, Belarus, Ukraine',
    chinaRailwayExpress3: 'Central Asia South Asia West Asia',
    chinaRailwayExpress4: 'Uzbekistan, Kazakhstan, Kyrgyzstan, Nepal, Iran, Istanbul',
    chinaRailwayExpress5: 'Europe',
    chinaRailwayExpress6: 'Mannheim, Prague, Sławkow, Tilburg, Nuremberg, Milan, Immingham',

    seaRail: 'Sea-rail combined transport',
    seaRail1: 'Guangzhou--Ningbo',
    seaRail2: '(Zengcheng West, Guangzhou International Port, Nansha Port)',
    seaRail3: 'Dongguan--Qingdao',
    seaRail4: '(Dalang Port)',

    schedule: 'schedule',
    columnWeek: 'column/week',
    aging: 'aging',
    day: 'days',
    hotLine: 'popular routes',

    hotLine1: 'Zengcheng West/Nansha Port/Guangzhou International Port/Dalang',
    hotLine11: 'Guosi/Shankou/Erlian/Manzhouli',
    hotLine12: 'Russia/Belarus',
    hotLine13: 'line introduction',
    // hotLine14: 'The route can choose to start from Zengcheng West/Nansha Port/Guangzhou International Port/Dalang, pass through Guosi/Shankou/Erlian/Manzhouli, and finally reach Russia/Belarus.',
    hotLine14: '',
    hotLine15: 'Further exert the effectiveness of the "China Railway Express + Seaport" model, promote the efficient connection between the "Silk Road Economic Belt" and the "21st Century Maritime Silk Road", and increase the business scale of trade cooperation between the Guangdong-Hong Kong-Macao Greater Bay Area and countries along the "Belt and Road" , to form a development pattern of internal and external linkage, production and marketing connection, complementary advantages and mutual promotion.',

    hotLine2: 'Xi\'an',
    hotLine21: 'Goss/Alashankou',
    hotLine22: 'Russia/Shushale/Central Asia',
    hotLine23: 'line introduction',
    // hotLine24: 'Exiting the country via Alashankou or Gos in Xinjiang, China, passing through Kazakhstan, Russia, and Belarus, and finally arriving in Warsaw, Poland, passing through 5 countries, the whole journey is 9048 kilometers, and it is expected to arrive at the destination in 12 days.',
    hotLine24: '',
    hotLine25: 'At present, the China-Europe Railway Express "Chang\'an" has reached 15 trunk lines to Central Asia and Europe on a regular basis, covering 45 countries and regions along the "Belt and Road". international logistics channel. In the first 11 months of 2020, a total of 3,441 China-Europe freight trains "Chang\'an" have operated, which is 1.8 times that of the same period last year.',

    hotLine3: 'Nansha Port',
    hotLine31: 'Goss',
    hotLine32: 'five countries in central asia',
    hotLine33: 'line introduction',
    // hotLine34: 'The Nansha Port-Guosi-Central Asia train has the characteristics of fixed departure time, stable running time and low cost. It is emphasized that the outbound and return trains are divided into two round trips, and the connection time of the train track change is strictly calculated, that is, by controlling the outbound and return trains to arrive at the reloading port at the same time, the container will be shipped as soon as the board is exchanged. The opening of public trains indicates that the timeliness of the Central Asia trains can be accurately controlled, the utilization rate of the whole process is full, and the waiting time is almost zero, which will fully realize a new stage of high-quality development. At the same time, it greatly meets the market\'s import demand for Central Asian bulk cargo (cotton yarn, mung beans, flour, virgin oil, electrolytic copper, ultramarine, cowhide, bread, honey, barley, wheat bran, candy, peanut kernels, potash fertilizer, etc.).',
    hotLine34: 'The Nansha Port-Guosi-Central Asia train has the characteristics of fixed departure time, stable running time and low cost. Emphasize that the outbound and return trains are separated from each other, and strictly calculate the connection time of the train track change, that is, by controlling the outbound and return trains to arrive at the transshipment port at the same time, the containers will be shipped as soon as the boards are exchanged',

    hotLine4: 'Chengdu/Chongqing',
    hotLine41: 'Goss/Alashankou',
    hotLine42: 'Europe/Russia',
    hotLine43: 'line introduction',
    // hotLine44: 'Departing from Chengxiang Station in Chengdu, exiting the country from Alashankou or Gosi, passing through Kazakhstan, Russia, Belarus, and ending at Lodz Station in Poland, the total distance is 9,965 kilometers and the running time is about 14 days. The sources of goods are mainly locally produced IT products and other export goods.',
    hotLine44: '',
    hotLine45: 'The name Yuxinou comes from the joint agreement of the railway and customs departments of the six countries along the route. "Yu" refers to Chongqing, "Xin" refers to Alashankou in Xinjiang, and "Ou" refers to Europe, collectively called "Yuxinou". As Chongqing City One of the important strategies to create an inland open highland, the China Railway Express (Yuxinou) officially opened in March 2011. As of early December 2022, the cumulative number of China Railway Express (Yuxinou) has exceeded 20,000.',

    hotLine5: 'Wuhan',
    hotLine51: 'Alashankou',
    hotLine52: 'Europe/Russia',
    hotLine53: 'line introduction',
    // hotLine54: 'Departing from Wujiashan Station in Wuhan, exiting the country via Alashankou or Gos, passing through Kazakhstan, Russia, Belarus and arriving in relevant cities in Poland, Czech Republic, Slovakia and other countries, the whole journey is about 10,700 kilometers, and the running time is about 15 days.',
    hotLine54: '',
    hotLine55: 'From the beginning of the China Railway Express (Wuhan) only one line from Wuhan to Pardubice, Czech Republic, now there are 37 stable cross-border transportation lines in China and Europe, covering 40 countries and 107 cities in Eurasia, gradually forming a " Channel parallel, multi-point direct" international logistics network system.',

    hotLine6: 'Zhengzhou',
    hotLine61: 'Goss／Alashankou',
    hotLine62: 'Europe/Russia',
    hotLine63: 'line introduction',
    // hotLine64: 'Departing from Putian Station in Zhengzhou, exiting the country from Alashankou or Guosi, passing through Kazakhstan, Russia, Belarus, Poland to Hamburg Station in Germany, the whole journey is 10,245 kilometers, and the running time is 11 to 15 days.',
    hotLine64: '',
    hotLine65: 'The first Zhengzhou-Europe International Railway Freight Train was launched on July 18, 2013, opening the "Silk Road on Land" between the Central Plains and Europe. The number of trains of the Zhengzhou-Europe Railway Express is "80001 times", which is the "No. 1" among the freight trains from all over the country to Europe. As of November 20, 2020, a total of 3,745 Zhengzhou-Europe trains have been operated, with a total accumulated cargo value of 15.55 billion US dollars and a cargo weight of 2.0204 million tons, of which 985 trains have been operated in 2020.',

  },
  ctc: {
    title: 'Core Technology Local Intelligence',
    tip: 'Intelligent AI Connecting Makes Great Future',
    video: 'Play Video',
    // 核心技术
    core: 'Core Technologies',
    face: 'Face Analysis',
    action: 'Behavior Analysis',
    defect: 'Defect Analysis',
    target: 'Target Analysis',
    // 人脸分析技术
    Face: 'Face Analysis Technology',
    message0: 'Face detection within millisecond for any given \nregular scenario, including face spoofing,\ngender, expression, and age detections, etc.',
    analysis: 'Technology Insights',
    message1: 'Support detection of side face, under partial \nocclusion or blurred face, and face detection\nin dim or backlight environments, etc.',
    expression: 'Expression Recognition',
    message2: 'Accurate recognition of 6 different basic facial \nexpressions and plus precise detection of blink,\nfatigue, and other expressions',
    //行为分析技术
    Action: 'Behavior Analysis Technology',
    message3: 'Automatic detection and recognition of people behavior \nin complex scenarios with rapid analysis of \nspecific hand gestures and abnormal behaviors',
    gesture: 'Hand Gesture Recognition',
    message4: 'Recognize hand position and gesture in images and videos \nCapable of identifying more than 20 common hand gestures',
    abnormal: 'Abnormal Motion Behavior Detection',
    message5: 'Accurate detection of abnormal behaviors such as \nfalling, fighting, drowning, and smoking, etc.',
    // 缺陷分析技术
    Defect: 'Defect Analysis Technology',
    message6: 'Extract features of the surface of the industrial objects \nand train to analyze the types of the defects such as\nspots, pits, scratches, and chromatic aberrations, etc.',
    steel: 'Defect Recognition on Steel Surface',
    message7: 'Identifies 46 common defects on the strip surface including \ncross breaks, scratches, dents, and corrosions, etc.',
    circuit: 'Defect Detection of Circuit Board Device',
    message8: 'Locate and analyze defects including weak welding, wire \ndisconnections, and missing electronic components, etc.',
    // 一般目标分析技术
    Target: 'General Target Analysis Technology',
    message9: 'Interpret the contents or images via the accurate detection \nand analysis of the images of graphs, texts, and colors, etc.',
    vehicle: 'Vehicle Recognition and \nLocation Identification',
    message10: 'The self-developed advanced machine learning technology \nis capable of identifying the front vehicles, traffic\nlanes, and traffic signs, etc. and provides warning in\nadvance for any potential hazards to reduce traffic\naccidents and enhance drive safety.',
    text: 'Text Recognition',
    message11: 'Offer multilingual and high-precision text detection and \nrecognition applied in multiple scenarios based on the\nadvanced machine learning technology of the industry, with\nup to 99% accuracy for printed text recognition',

    anomaly: 'Unattended Items Recognition\nand Identification',
    message13: 'Recognize and identify unattended items and \nautomatically record and upload data',
    // 视频分析技术
    VideoAnalysis: {
      name: 'Video Analysis',
      msg1: {
        title: 'Video Analysis Technology',
        introduction: 'Real-time retrieve, mark and process the key features from \nthe videos, and create corresponding event records \nand warnings via original technology of video analysis'
      },
      msg2: {
        title: 'Smart Video Search',
        introduction: 'Retrieve videos quickly and analyze massive \nvideo data with high efficiency'
      },
      msg3: {
        title: 'Auto Video Tagging',
        introduction: 'Process and interpret massive video contents,\ncreate textual tags, and improve video\nrecommendations and user searching experience\nvia algorithms of automatic video tagging'
      },
      msg4: {
        title: 'Video Super Resolution',
        introduction: 'Convert low-resolution video to high-resolution video for a \nbetter visual experience via artificial intelligence technology'
      },
    },
    //数据分析技术
    DataAnalysis: {
      name: 'Data Analysis',
      msg1: {
        title: 'Data Analysis Technology',
        introduction: 'Process massive data to predict trends and alert unusual \nparameters and outlier data via the AI technology'
      },
      msg2: {
        title: 'Financial Evaluation System \nfor Non-listed Companies',
        introduction: 'Analyze massive financial data of non-listed companies via \nmultidimensional modeling method, automatically generate \nfinancial evaluation of non-listed companies based on\nthe massive data analysis, and provide professional\nrecommendations for primary investment market'
      },
      msg3: {
        title: 'Smart Building Data Analysis',
        introduction: 'Monitor and detect building status in real time via analysis \nof multi-sensor data including central air-conditioner,\nwater, electricity, gas, green energy, and pressure system, etc.,\nand provide warning in advance for any unusual data \npatterns and real-time alert for any malfunction data'
      },
      msg4: {
        title: 'Smart Device Fault Diagnosis',
        introduction: 'Diagnose device fault in time and predict potential fault via \ncollection and analysis of data from the device sensor'
      },
    },
    localIntelligent: {
      name: 'Local Intelligence',
      msg1: {
        title: 'Local Intelligence Technology',
        introduction: 'Synergize Learning-on-chip, Local Intelligence,\nand Cloud Intelligence technologies, and \nprovide real-time video and data analysis'
      },
      msg2: {
        title: 'Fusion of Multiple AI Algorithms',
        introduction: 'Integrate technologies such as deep learning, \nELM, SVM, video analysis, and data analysis'
      },
      msg3: {
        title: 'Multiple Applied Scenarios',
        introduction: 'Learning-on-chip technology with high performance\nand low power consumption\nTo be applied in smart home, smart vehicle,\nand smart device, etc.\n'
      },
    }
  },
  companyProduct: {
    // 引导机器人相关

    tip0: 'Created and designed with core machine learning algorithm\ntechnology and other advanced AI technologies.',
    video: '观看视频',

    robot: 'Smart Robots',
    guiding: 'Smart Direction Robot',
    delivery: 'Smart Delivery Robot',
    security: 'Smart Security Robot',

    patrol: 'Flexible Selections of \nVisiting Routes',
    message0: {
      message01: 'Audio selections of visiting spots',
      message02: 'Visiting spots selection via touch screens',
    },
    avoidance: 'Smart Audio Conversation \nand Video Monitoring',
    message1: {
      message11: 'Support customized audio conversation',
      message12: 'Remote on-site view monitoring via apps',
    },
    voice: 'Autonomous Recharge',
    message2: {
      message21: 'Intelligent battery volume monitoring system',
      message22: 'Autonomously navigate back to the charging station for recharge',
    },
    visiting: 'Multi-scenario Applications',
    message3: {
      message31: 'Office buildings, malls, and hotels',
      message32: 'Various indoor scenes',
    },

    //派送机器人相关
    word: 'Deliver documents indoors, hotel room service items, and hospital\nmedications, etc. and compatible with audio conversation.',
    patrol2: 'Unlock via Intelligent \nBiometric Identification',
    message4: {
      message01: 'Support unlock via face recognition',
      message02: 'Support unlock via fingerprint recognition',
    },
    avoidance2: 'Flexible Capacity for \nDelivery Storage Spaces',
    message5: {
      message11: 'Multi types of storage spaces for different \nmedications and files, etc.',
      message12: 'Simple, safe, convenient, and practical',
    },
    voice2: 'Autonomous Recharge',
    message6: {
      message21: 'Intelligent battery volume monitoring system',
      message22: 'Autonomously navigate back to the charging station for recharge',
    },
    visiting2: 'Multi-scenario Applications',
    message7: {
      message31: 'Hospitals, malls, and offices',
      message32: 'Various indoor scenes',
    },
    //安保机器人
    securityRobot: {
      title: 'Smart Security Robot',
      introduction: 'Powered by “Local Intelligence” video analysis technology, smart\nsecurity robot can detect and identify abnormal scenarios including\nproperty intrusion, violence, suspicious packages and fire, etc. \nand send alarm automatically.'
    },

    patrol3: '“Local Intelligence” Video \nAnalysis Technology',
    message8: {
      message01: 'Abnormal intrusion',
      message02: 'Fighting and falling, etc.',
    },
    avoidance3: 'Real-time Video Remote \nUpload and Retrieval',
    message9: {
      message11: 'Send alarm for abnormal scenarios and upload related \nvideos to the servers or remote apps',
      message12: 'Real-time monitor and check from webs or apps',
    },
    voice3: 'Autonomous Recharge',
    message10: {
      message21: 'Intelligent battery volume monitoring system',
      message22: 'Autonomously navigate back to the charging station for recharge',
    },
    visiting3: 'Multi-scenario Applications',
    message11: {
      message31: 'Office buildings, shopping malls, and hotels',
      message32: 'Laboratories, libraries, and museums',
    },

    AccessControl: 'Smart Access Control',
    thermometer: 'Smart Temperature\nMeasurement System',
    ADAS: 'Advanced Driver\nAssistance Systems (ADAS)',
    LocChip: '“Learning-On-Chip”\nSmart Module',
    TerminalCore: 'Core Board\nof Smart Terminal'
  },

  // partner: {
  //     partner: '合作伙伴',
  //     technology: '技术合作伙伴',
  //     business: '商务合作伙伴',

  //     Technology: '技术合作伙伴',

  //     Business: '商务合作伙伴',
  //     Singapore: '新加坡樟宜机场',
  //     message: '随着近年来机场视频监控系统规模的迅速增长，为覆盖机场建筑内外及周边区域， 摄像头安放的数量，快速增多，如新加坡樟宜机场，北京、上海、深圳等国际机场，平均每个 机场的监控规模超过 5000 路。大量的视频数据，给实时监视报警和视频数据的有效使用带来了新的机会和挑战。大量的视频和相应产生的数字录像数据，使操作人员通过观测每一路视频从而发现报警事件变得越来越困难。此外在事后分析报警事件时，因视频监控系统缺乏对视频的智能分析，视频与行为之间未建立对应关系，录像数据无法被有效地检索。',
  // },
  aboutUs: {
    us: 'About Us',
    company: 'About Company',
    // news: '新闻资讯',
    address: 'Company Address',
    contact: 'Contact Us',
    companyCondtion: 'Company Environment',
    companyActivity: 'Company Events',
    logo: 'ZHONGLING LOGITICS',

    message0: {
      message01: 'Guangzhou Quanxiantang international Logistics CO.,LTD located in Baiyun District, Guangzhou, China. The registered capital of CNY 20 million, the company has obtained the first-class freight forwarding enterprise qualification issued by the Ministry of Commerce of the People\'s Republic of China, with the“International shipping agency”, “Non-vessel carrier” and professional (container) road transport license issued by the Ministry of Communications, ZHONGLING is also a member of the Continental Bridge (the world\'s largest cross-border transport service platform for the International Railway Logistics Industry-RAssociationtion and ChinahInternationaloFreightiAssociationtiCIFACIFA) . In order to actively respond to the country\'s “Belt and Road” strategic decision-making and promotion, the company focuses on goods from domestic to European, Russian and Central Asian regions, ZHONGLING has integrated logistics services of railway, sea, air, sea, rail and air card. At the same time, in order to connect with the international world faster and better, the company adheres to the modern logistics concept of“Supply chain management integration” and wins the trust of many customers with high-quality service. The company has an excellent professional team and efficient and efficient operation mode, to integrity, safety, fast, professional principles for customers to constantly optimize the logistics links, reduce logistics costs, to provide domestic and foreign customers with railway, road, maritime and customs declaration, warehousing, handling, container storage and other“One-stop” logistics services, for the company has laid a good foundation for development, continuously provide the best transportation plan for our customers.',
      message02: 'The company\'s founding team consists of AI Doctors from Nanyang Technological University (NTU), Singapore, ranked 11th in the world, and top talents from first-class universities worldwide. In 2017, the original "Local Intelligence" algorithm was ranked the Top 2 out of the Top 10 worldwide by Google Scholar in its Classic Papers: “Articles That Have Stood the Test of Time for the Past 10 Years”, which has a fundamental influence in the AI industry.',
      message03: 'The company develops smart AI systems that can be easily applied in various scenarios and smart terminal products powered by "Local Intelligence" technology, and focuses on the development of integrated overall AI solutions for the AI high-tech park. In the future, Mind PointEye will be collaborating and partnering together with the leading companies from various industries across the world to build an ecosystem of “Local Intelligence” technology.'
    },
    mission: 'Mission',
    tip: 'Take the Silk Road and Create a Better Tomorrow',
    vision: 'Vision',
    tip1: 'Facilitating the development of logistics along the \'Belt and Road Initiative\'',
    tip11: 'To Become World\'s Leading\nCompany of Edge AI \n\nTo Accelerate World\'s Transition\nto Intelligent Era',
    culture: 'Values',

    // tip2: '我们正在快速前行中',
    // message1: {
    //     message10: '广东省副省视察工作',
    //     message11: '商务部辛部长视察工作',
    //     message12: '广东省委书记视察工作',
    //     message13: '全线通与中兴签约',
    // },
    tip3: 'Rapidly Growing Corporate Network',
    city1: 'Shenzhen',
    add1: 'C1009, Floor 10, Block C, Hengboli Rongfeng Industrial Park, Xuegang North Road, Qinghu Community, Longhua Street, Longhua District, Shenzhen',
    city2: 'Yangzhou',
    add2: '505-1 Changjiang West Road, Jiangdu, Yangzhou City, Jiangsu Province, China',
    city3: 'Singapore',
    add3: 'Vision Exchange, 2 Venture Drive, #08-25, Singapore',

    tip4: 'Looking Forward to Working with You',
    cooperation: 'Business Cooperation',
    cooperation2: 'Talent Recommendation',
    phone: 'Contact Number',
    abus: 'Follow Us',
    tip5: 'Official WeChat QR code'
  },
  contactUs: {
    us: 'contact us',
    address: 'Company address',
    contact: 'Contact us',
    tip3: 'Our network is rapidly forming',
    city1: 'ShenZhen',
    add1: 'C1009, 10th Floor, Block C, Hengbo Li Rongfeng Industrial Park, Xuegang North Road, Qinghu Community, Longhua Street, Longhua District, Shenzhen',
  },
  joinUs: {
    us: '加入我们',
    environment: '公司环境',
    activities: '公司活动',
    position: '招聘岗位',

    Environment: 'Company Environment',
    place: 'Office Environment',
    tip: 'Wide Bright Spacious',
    scene: 'Exhibition Hall',
    tip1: 'Present the Future \nImagine with No Limits',

    Activities: 'Company Events',
    meeting: 'Academic Research \nand Industry Seminar',
    tip2: 'We have always been stayed abreast of the latest AI industry technology',
    // message0: {
    //     message01: '中国扬州第二届人工智能产业发展应用峰会',
    //     message02: '国际人工智能峰会',
    //     message03: '全线通产品发布会',
    //     message04: '中国扬州数字经济发展大会',
    // },
    annual: 'Teambuilding',
    tip3: 'Join Us for a Bright Future',
    companyNewsTitle: "Company news",
    companyNews: "Company news",
    // companyNewsTip: "我们正在快速前行中",
    message2: {
      message01: 'Secretary of the CPC Guangdong Provincial Committee inspected the work',
      message02: 'Inspection of Guangdong Province',
      message03: 'Minister Xin of the Ministry of Commerce inspected the work',
      message04: 'Guangdong News Network reported Quanxiantang international',
    },
  },
  bottom: {
    product: 'Products',
    chip: 'Smart Modules',
    robot: 'Smart Robots',
    terminal: 'Smart Terminals',
    car: 'AI Patrol Car',
    entry: 'Fast entry',
    news: 'News',
    coreTechnology: 'Technologies',
    aboutUs: 'About Us',
    joinUs: '招贤纳士',
    partner: '合作伙伴',
    contactUs: 'Contact Us',
    allVisited: 'Total visits',
    solution: 'Solutions',
  },
  // 2020-02-13新增
  newSolutions: en_solutions,
  newProducts: en_products
}



// WEBPACK FOOTER //
// ./src/assets/utils/lang/en.js